<template>
<div>
  <v-navigation-drawer
    app
    height="100%"
    color="#f1efed"
    v-model="drawer"
  >
    <v-list class="pt-0 mt-0">
      <v-list-item class="gold" two-line>
        <span class="mx-auto">
        <a href="https://www.adelphi.edu">  
        <v-img
          src="../assets/adelphi-logo.png"
          alt="Adelphi University"
          class="shrink mr-2"
          max-width="150"
          contain
        />
        </a>
        </span>
      </v-list-item>

      
      <div>
      <v-list-item
        dense
        link
        class="px-8"
        v-for="item in this.nav_items"
        :key="item.title"
        router
        :to="item.route"
      >
        <v-list-item-icon>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      </div>
      <!-- <div v-else>
        <v-skeleton-loader
            class="mx-auto"
            type="list-item-avatar"
            style="background-color: #F1EFED"></v-skeleton-loader>
      </div> -->
      
    </v-list>
    <template v-slot:append>
        <div>
          <v-divider class="mx-8"></v-divider>
          <v-list>
          <v-list-item
          dense
          link
          class="px-8"
          router
          to="/support">
            <v-list-item-icon>
              <v-icon>mdi-help-circle</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Support</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
          dense
          link
          class="px-8"
          router
          to="/"
          @click="logOut()">
            <v-list-item-icon>
              <v-icon>mdi-logout-variant</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Log Out</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          </v-list>
        </div>
      </template>
  </v-navigation-drawer>

 <!-- Top Nav -->

    <v-app-bar
      v-if = "$vuetify.breakpoint.mdAndDown"
      app
      color="#ffb500"
      class="hidden-lg-and-up"
      flat
      @click="drawer = !drawer"
    >
    <v-app-bar-nav-icon class="ml-5"></v-app-bar-nav-icon>
      <div>
         <a href="https://www.adelphi.edu">
        <v-img
          src="../assets/adelphi-logo.png"
          alt="Adelphi University"
          class="shrink mr-2"
          max-width="160"
          contain
        />
        </a>
      </div>
    </v-app-bar>
</div>
</template>

<script>
export default {
  

  data() {
    return {
      selectedItem: 0,
      drawer: false,
      // nav_items: [
      //   {
      //     title: "Courses",
      //     icon: "mdi-pencil",
      //     route: "/courses"
      //   },
      //   {
      //     title: "Registration",
      //     icon: "mdi-pencil",
      //     route: "/registration"
      //   }
      // ]
    };
  },
  // computed: {
  //   nav_items: function() {
  //     return this.$store.state.getters.nav_items
  //   }
  // },
  mounted() {
    this.drawer = (this.$vuetify.breakpoint.width >= 1264 ? true : false)
  },

  methods: {
      async logOut() {

        // await this.$gAuth.signOut()
        this.$store.dispatch('logout')
          .then(function() {
            window.console.log('Logged Out')
          })
      }
  },

  computed: {
    nav_items: function() {
      return this.$store.getters.nav_items
    }
  }
};
</script>
